<template>
  <div class="home">
    <div class="image">
      <van-image
        width="100px"
        style="padding: 20px"
        height="100px"
        fit="contain"
        :src="
          isAdopt
            ? 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/account_success.png'
            : 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/account_processing.png'
        "
      />
    </div>
    <div class="theme-color" v-if="form.oa_state === 0">
      <div v-if="form.net_state <= 2">网上资料审批中</div>
      <div v-if="form.net_state === 3">网上资料审批通过</div>
      <div v-if="form.net_state === 4">网上资料审批退回</div>
      <div v-if="!isMajorLocal">
        <div v-if="form.mail_state <= 2">邮寄材料审批中</div>
        <div v-if="form.mail_state === 3">邮寄材料审批通过</div>
        <div v-if="form.mail_state === 4">邮寄材料审批退回</div>
      </div>
    </div>
    <div class="wraper theme-color" v-if="form.oa_state === 0">
      <div v-if="showA" style="margin-top: 20px">
        我们正在认真审批您的资料，审批后我们将短信通知，请留意！
      </div>
      <div v-if="showB" style="margin-top: 20px">
        请确认往我司账户转账不少于1万的港币或等值美元(<span class="link" @click="handleShowAccount"
          >收款账户</span
        >)。
      </div>
      <div v-if="showC && !isMajorLocal" style="margin-top: 20px; word-wrap: break-word;">
        {{ form.mail_step_info }}
      </div>
      <div v-if="showD && !isMajorLocal" style="margin-top: 20px">
        <div v-if="form.auth_type === '香港/合资格银行'">
          <span>确认待邮寄材料无误后，将材料邮寄到我司。</span><br />
          <span>邮寄材料：专业投资者证明原件</span><br />
          <span>收件地址：香港中环皇后大道中99号中环中心39楼5室</span><br />
        </div>
        <div v-else>
          <span>完成线下见证，确认待邮寄材料无误后，将材料邮寄到我司。</span><br />
          <span
            >邮寄材料：开户申请签字材料（稍后发送至您的邮箱：{{ email }}，请下载打印并签字）、
            身份证件复印件、住址证明、银行证明、专业投资者证明（仅限专业投资者）</span
          ><br />
          <span>收件地址：香港中环皇后大道中99号中环中心39楼5室</span><br />
        </div>
      </div>
      <div v-if="showE" style="margin-top: 20px">
        <van-steps class="step theme-color-bg" active="-1" direction="vertical">
          <van-step v-for="item in form.net_step_info" :key="item.type">
            {{ typeList[item.type - 1] }}
            <template #inactive-icon>
              <div class="circle right" v-if="item.approveStatus === 1">
                <van-icon name="success" />
              </div>
              <div class="circle" v-else><van-icon name="cross" /></div>
            </template>
            <div style="margin-top: 10px; word-wrap: break-word">{{ item.comment }}</div>
          </van-step>
        </van-steps>
      </div>
      <div v-if="showE">
        <div style="width: 100%; text-align: center; margin-top: 20px">
          <van-button type="primary" style="width: 80%; margin: auto" @click="handleGoChoose">
            立即完善网上资料
          </van-button>
        </div>
      </div>
      <div v-else>
        <div style="width: 100%; text-align: center; margin-top: 20px">
          <van-button type="primary" style="width: 80%; margin: auto" @click="handleGoCheck">
            查看当前有效资料
          </van-button>
        </div>
      </div>
    </div>
    <div v-else-if="form.oa_state === 1">
      <p class="theme-color">恭喜，开户成功！</p>
      <p class="theme-color" style="word-wrap: break-word;">{{ form.approve_comment }}</p>
      <div>
        <div class="btn-card" v-if="investorConfig.accountManage">
          <h3 class="title">账户管理</h3>
          <div @click="handleAddAccount" class="row" v-if="investorConfig.showAddAccount">
            <svg
              t="1703127939169"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7176"
              width="200"
              height="200"
            >
              <path
                d="M762.88 937.984q-43.008 0-81.408-16.384t-67.072-45.056-45.056-67.072-16.384-81.408 16.384-81.408 45.056-66.56 67.072-44.544 81.408-16.384 81.408 16.384 66.56 44.544 44.544 66.56 16.384 81.408-16.384 81.408-44.544 67.072-66.56 45.056-81.408 16.384zM866.304 694.272l-75.776 0 0-70.656q0-14.336-9.216-24.576t-23.552-10.24-22.528 10.24-8.192 24.576l0 70.656-66.56 0q-14.336 0-24.576 10.24t-10.24 24.576 10.24 21.504 24.576 7.168l66.56 0 0 72.704q0 14.336 8.192 24.576t22.528 10.24 23.552-10.24 9.216-24.576l0-72.704 75.776 0 0 2.048q14.336 0 24.576-8.192t10.24-22.528-10.24-24.576-24.576-10.24zM613.376 439.296q-4.096 16.384-8.192 29.696-4.096 11.264-10.24 23.04t-13.312 17.92q-9.216 7.168-12.8 15.36t-6.144 16.896-5.632 17.92-10.24 18.432q-23.552 30.72-35.328 59.392t-16.384 55.296-2.56 52.736 8.192 50.688q4.096 18.432 12.288 38.4t24.064 40.96 40.448 40.96 61.44 38.4q-24.576 5.12-57.344 9.216-27.648 3.072-68.096 5.632t-92.672 2.56q-26.624 0-61.952-2.048t-72.704-5.12-73.728-7.168-66.56-8.704-51.2-9.728-26.112-9.216q-9.216-8.192-14.336-45.568t3.072-97.792q5.12-33.792 27.136-51.712t51.712-28.16 61.952-18.944 56.832-24.064q19.456-12.288 29.696-23.04t14.336-22.016 4.096-23.552-1.024-26.624q-2.048-21.504-14.848-33.792t-27.136-24.576q-8.192-6.144-14.336-18.432t-10.24-23.552q-5.12-13.312-8.192-29.696-7.168-2.048-13.312-6.144-5.12-4.096-11.264-12.288t-11.264-24.576q-5.12-15.36-3.584-28.672t5.632-22.528q4.096-11.264 11.264-19.456 0-34.816 4.096-69.632 4.096-29.696 12.8-63.488t28.16-60.416q18.432-25.6 39.424-41.984t43.52-25.6 45.056-12.8 43.008-3.584q26.624 0 51.2 6.144t45.568 16.384 37.376 23.04 26.624 26.112q23.552 29.696 34.304 65.536t15.872 67.584q5.12 36.864 4.096 73.728 6.144 5.12 10.24 12.288 4.096 6.144 6.144 16.384t0 25.6q-2.048 19.456-8.192 30.72t-13.312 17.408q-8.192 7.168-17.408 10.24z"
                p-id="7177"
                fill="#3389F7"
              ></path>
            </svg>
            补充开户
          </div>
          <div @click="handleRiskUpdate" class="row" v-if="investorConfig.showYearlyRisk">
            <svg
              t="1703128007724"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="10529"
              width="200"
              height="200"
            >
              <path
                d="M768 326.4c-70.4 0-134.4-57.6-134.4-134.4V89.6c0-6.4-6.4-19.2-19.2-19.2h-384c-51.2 0-89.6 38.4-89.6 89.6v697.6c0 51.2 38.4 89.6 89.6 89.6h556.8c51.2 0 89.6-38.4 89.6-89.6V339.2c0-6.4-6.4-19.2-19.2-19.2H768z m-19.2 467.2H275.2c-6.4 0-19.2-6.4-19.2-19.2v-12.8c0-6.4 6.4-19.2 19.2-19.2h467.2c6.4 0 19.2 6.4 19.2 19.2v12.8c0 12.8-6.4 19.2-12.8 19.2z m0-153.6H275.2c-6.4 0-19.2-6.4-19.2-19.2v-12.8c0-6.4 6.4-19.2 19.2-19.2h467.2c6.4 0 19.2 6.4 19.2 19.2v12.8c0 12.8-6.4 19.2-12.8 19.2z m0-153.6H275.2c-6.4 0-19.2-6.4-19.2-19.2v-6.4c0-6.4 6.4-19.2 19.2-19.2h467.2c6.4 0 19.2 6.4 19.2 19.2v12.8c0 6.4-6.4 12.8-12.8 12.8z m12.8 0"
                p-id="10530"
                fill="#3389F7"
              ></path>
              <path
                d="M678.4 128v57.6c0 51.2 38.4 89.6 89.6 89.6h57.6c19.2 0 32-25.6 12.8-38.4l-128-128c-6.4-12.8-32 0-32 19.2z m0-51.2"
                p-id="10531"
                fill="#3389F7"
              ></path>
            </svg>
            风险评测
          </div>
          <div @click="handleGoIsda" class="row" v-if="investorConfig.showIsda">
            <svg
              t="1703128033172"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11685"
              width="200"
              height="200"
            >
              <path
                d="M1013.04039 527.1L892.84039 196.9c-0.9-2.6 1-5.4 3.8-5.4H973.34039c2.2 0 4-1.8 4-4.1 0-16.5-6.7-31.5-17.6-42.4-10.9-10.9-25.9-17.6-42.4-17.6H560.34039c-8.8 0-16-7.2-16-16V64.1c0-17.5-13.8-32.2-31.3-32.6-9.1-0.2-17.4 3.4-23.4 9.4-5.8 5.8-9.4 13.8-9.4 22.6v48c0 8.8-7.2 16-16 16H108.34039c-33.1 0-60 26.9-60 60 0 1.1 0.5 2.1 1.2 2.8 0.7 0.7 1.7 1.2 2.8 1.2h73.7c2.8 0 4.7 2.8 3.8 5.4L9.64039 527.1c-0.3 0.8-0.6 1.6-1 2.4C-3.75961 555-3.05961 584.9 12.34039 608.7c11.9 18.5 27.2 35 45 48.9 36.9 28.7 84.7 46 137 46 81.4 0 152-41.9 187.2-103.4 12.9-22.5 11.3-49.8-2-72.1-0.2-0.3-0.3-0.6-0.4-0.9L258.84039 196.9c-0.9-2.6 1-5.4 3.8-5.4H384.34039c53 0 96 43 96 96v583.6c0 23.6-17.2 43.8-40.5 47.4-63.4 9.8-115.2 30.9-143.6 58h448.3c-30.6-29.1-88-51.2-157.9-60-24.1-3-42.2-23.4-42.2-47.6V287.5c0-53 43-96 96-96h120.5c2.8 0 4.7 2.8 3.8 5.4L644.34039 527.1c-0.2 0.5-0.4 1-0.7 1.5-13.3 24.3-13.8 53.6 0.8 77.2 36.2 58.4 105 97.8 183.9 97.8 81.3 0 151.8-41.8 187-103.1 13-22.6 11.3-50.1-2-72.5-0.1-0.4-0.2-0.6-0.3-0.9zM194.24039 639.5c-35.8 0-70.2-11.4-97.1-32H291.34039c-26.8 20.6-61.3 32-97.1 32z m122.6-96h-245l118.8-326.4c1.3-3.5 6.2-3.5 7.5 0l118.7 326.4z m511.6 96c-35.8 0-70.2-11.4-97.1-32h194.1c-26.8 20.6-61.3 32-97 32z m-121.9-96l118.4-325.4c1.3-3.5 6.2-3.5 7.5 0l118.4 325.4H706.54039z"
                p-id="11686"
                fill="#3389F7"
              ></path>
            </svg>
            {{ investorConfig.showIsdaBtnText }}
          </div>
          <div @click="handleOpenSubAccount" class="row" v-if="investorConfig.showOpenSubAccount">
            <svg
              t="1703127974359"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9472"
              width="200"
              height="200"
            >
              <path
                d="M790.4 707.2l233.6 3.2c0-121.6-60.8-294.4-211.2-294.4-83.2 0-128 41.6-163.2 102.4 70.4 32 112 112 140.8 188.8z m22.4-604.8c-41.6 0-83.2 19.2-108.8 44.8 28.8 35.2 44.8 80 44.8 131.2 0 35.2-9.6 70.4-25.6 99.2 25.6 19.2 57.6 28.8 89.6 28.8 83.2 0 153.6-67.2 153.6-153.6-3.2-83.2-70.4-150.4-153.6-150.4zM233.6 707.2H0c0-121.6 60.8-294.4 211.2-294.4 83.2 0 128 41.6 163.2 102.4-70.4 35.2-112 115.2-140.8 192z m-22.4-608c41.6 0 83.2 19.2 108.8 44.8-25.6 38.4-41.6 83.2-41.6 134.4 0 35.2 9.6 70.4 25.6 99.2-25.6 19.2-57.6 28.8-89.6 28.8-83.2 0-153.6-67.2-153.6-153.6 0-83.2 67.2-153.6 150.4-153.6z m0 0"
                fill="#3389F7"
                p-id="9473"
              ></path>
              <path
                d="M220.8 905.6c0-169.6 76.8-406.4 288-406.4 214.4 0 297.6 240 297.6 409.6"
                fill="#3389F7"
                p-id="9474"
              ></path>
              <path
                d="M297.6 278.4a214.4 214.4 0 1 0 428.8 0 214.4 214.4 0 0 0-428.8 0z m0 0"
                fill="#3389F7"
                p-id="9475"
              ></path>
            </svg>
            开立子账户
          </div>
        </div>
        <div class="btn-card" v-if="investorConfig.accountInfo && isOpenOnline">
          <h3 class="title">个人信息维护</h3>
          <div @click="handleChangeInfo" class="row" v-if="investorConfig.showChangeInfo">
            <svg
              t="1703128060765"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12730"
            >
              <path
                d="M369.178947 614.4c5.389474-8.084211 8.084211-16.168421 10.778948-21.557895 5.389474-2.694737 10.778947-8.084211 16.168421-16.168421 16.168421-21.557895 5.389474-37.726316 0-48.505263 2.694737-13.473684 5.389474-29.642105 5.389473-48.505263-2.694737-26.947368-26.947368-70.063158-88.926315-70.063158-59.284211 0-86.231579 35.031579-88.926316 70.063158 0 18.863158 2.694737 35.031579 5.389474 48.505263-5.389474 10.778947-13.473684 26.947368 0 48.505263 5.389474 10.778947 13.473684 16.168421 16.168421 16.168421 2.694737 8.084211 5.389474 13.473684 8.08421 18.863158l2.694737 2.694737v2.694737s0 2.694737 0 0v5.389474s-16.168421 21.557895-53.894737 29.642105c-35.031579 8.084211-72.757895 16.168421-72.757895 70.063158 0 10.778947 10.778947 24.252632 24.252632 24.252631h312.589474c13.473684 0 24.252632-10.778947 24.252631-24.252631 0-53.894737-37.726316-61.978947-72.757894-70.063158-37.726316-8.084211-53.894737-29.642105-53.894737-29.642105v-8.084211m-196.71579 99.705263c2.694737-10.778947 13.473684-13.473684 43.11579-21.557895 51.2-10.778947 72.757895-40.421053 75.452631-43.115789 8.084211-10.778947 8.084211-21.557895 8.084211-29.642105 0-5.389474-2.694737-10.778947-2.694737-16.168421v-2.694737c0-2.694737-2.694737-2.694737-2.694737-5.389474-2.694737-2.694737-5.389474-8.084211-5.389474-13.473684-2.694737-5.389474-8.084211-13.473684-10.778947-16.168421l-2.694737-2.694737c-2.694737-2.694737-5.389474-2.694737-8.08421-8.084211-2.694737-2.694737-2.694737-2.694737 2.694737-13.473684V538.947368c2.694737-2.694737 2.694737-10.778947 0-16.168421-2.694737-10.778947-5.389474-24.252632-5.389474-40.421052 0-13.473684 13.473684-35.031579 51.2-35.031579 40.421053 0 51.2 24.252632 51.2 35.031579 0 16.168421-2.694737 29.642105-5.389474 43.115789 0 5.389474 0 10.778947 2.694737 16.168421l2.694737 5.389474c0 2.694737 2.694737 5.389474 2.694737 8.08421l-8.084211 8.084211-2.694737 2.694737c-2.694737 2.694737-8.084211 10.778947-10.778947 16.168421 0 5.389474-5.389474 13.473684-8.084211 16.168421l-2.694736 5.389474c0 2.694737-5.389474 8.084211-5.389474 16.168421s0 18.863158 8.08421 29.642105c2.694737 2.694737 24.252632 32.336842 75.452632 43.115789 29.642105 5.389474 37.726316 10.778947 43.115789 21.557895H167.073684z"
                fill="#3389F7"
                p-id="12731"
              ></path>
              <path
                d="M929.684211 137.431579h-835.368422c-32.336842 0-59.284211 26.947368-59.28421 59.28421v633.263158c0 32.336842 26.947368 59.284211 59.28421 59.284211h835.368422c32.336842 0 59.284211-26.947368 59.28421-59.284211V196.715789c0-32.336842-26.947368-59.284211-59.28421-59.28421z m-835.368422 37.726316h835.368422c10.778947 0 21.557895 10.778947 21.557894 21.557894v88.926316H72.757895V196.715789c0-13.473684 10.778947-21.557895 21.557894-21.557894z m835.368422 673.68421h-835.368422c-10.778947 0-21.557895-10.778947-21.557894-21.557894V320.673684h878.48421v506.610527c0 13.473684-10.778947 21.557895-21.557894 21.557894z"
                fill="#3389F7"
                p-id="12732"
              ></path>
              <path
                d="M889.263158 441.936842H603.621053c-10.778947 0-18.863158 8.084211-18.863158 18.863158s8.084211 18.863158 18.863158 18.863158H889.263158c10.778947 0 18.863158-8.084211 18.863158-18.863158s-8.084211-18.863158-18.863158-18.863158zM889.263158 563.2H603.621053c-10.778947 0-18.863158 8.084211-18.863158 18.863158s8.084211 18.863158 18.863158 18.863158H889.263158c10.778947 0 18.863158-8.084211 18.863158-18.863158s-8.084211-18.863158-18.863158-18.863158zM889.263158 681.768421H603.621053c-10.778947 0-18.863158 8.084211-18.863158 18.863158s8.084211 18.863158 18.863158 18.863158H889.263158c10.778947 0 18.863158-8.084211 18.863158-18.863158s-8.084211-18.863158-18.863158-18.863158zM129.347368 250.610526h53.894737c10.778947 0 18.863158-8.084211 18.863158-18.863158s-5.389474-18.863158-16.168421-18.863157h-53.894737c-10.778947 0-18.863158 8.084211-18.863158 18.863157s5.389474 18.863158 16.168421 18.863158zM264.084211 250.610526h53.894736c10.778947 0 18.863158-8.084211 18.863158-18.863158s-8.084211-18.863158-18.863158-18.863157h-53.894736c-10.778947 0-18.863158 8.084211-18.863158 18.863157s8.084211 18.863158 18.863158 18.863158z"
                fill="#3389F7"
                p-id="12733"
              ></path>
            </svg>
            更改账户资料
          </div>
          <div @click="handleGoCheck" class="row" v-if="investorConfig.showViewInfo">
            <svg
              t="1703128109881"
              class="icon"
              viewBox="0 0 1154 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="17249"
              width="200"
              height="200"
            >
              <path
                d="M1015.808 64.512q62.464 0 99.84 31.744t37.376 96.256l0 568.32q0 27.648-10.24 52.224t-28.16 43.008-41.984 29.184-50.688 10.752l-892.928 0q-26.624 0-50.176-10.24t-40.96-27.136-27.648-39.424-10.24-48.128l0-580.608q0-55.296 33.792-90.624t95.232-35.328l886.784 0zM287.744 253.952q-19.456 0-36.864 7.168t-30.72 19.968-20.992 30.72-7.68 38.4 7.68 37.888 20.992 30.72 30.72 20.992 36.864 7.68q21.504 0 39.424-7.68t30.72-20.992 20.48-30.72 7.68-37.888q0-41.984-27.648-69.12t-70.656-27.136zM448.512 608.256q0-19.456-7.68-37.376t-20.48-30.72-30.72-20.48-37.376-7.68l-128 0q-39.936 0-67.584 28.16t-27.648 68.096l0 4.096 0 92.16 319.488 0 0-92.16 0-4.096zM923.648 709.632q20.48 0 30.208-10.24t9.728-24.576-11.264-25.088-31.744-10.752l-305.152 0q-20.48 0-30.72 10.752t-10.24 25.088 10.24 24.576 29.696 10.24l309.248 0zM924.672 577.536q20.48 0 29.696-10.24t9.216-24.576q0-15.36-8.704-25.6t-29.184-10.24l-313.344 0q-20.48 0-29.696 10.24t-9.216 25.6q0 14.336 8.704 24.576t29.184 10.24l313.344 0zM925.696 447.488q15.36 0 26.624-10.24t11.264-24.576-11.264-23.04-26.624-8.704l-207.872 0q-15.36 0-26.112 8.704t-10.752 23.04 10.752 24.576 26.112 10.24l207.872 0z"
                p-id="17250"
                fill="#3389F7"
              ></path>
            </svg>
            查看当前有效资料
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage, Button, Steps, Step, Icon, Dialog } from "vant";
import { useStore } from "vuex";
import { onMounted, ref } from "vue";
import httpApi from "../../utils/httpApi";
import httpAddApi from "../../utils/httpAddApi";

const alertMsg = `
注意：
1.必须用认证身份所绑定的银行卡转账不少于1万的港币或等值美元；
2.若未及时上传汇款凭证，后续请将凭证发送到customer-service@beevestsec.com，以便加快核实。

港币账户
银行名称： DBS Bank (Hong Kong) Limited
SWIFT码： DHBKHKHHXXX 
户口名称： BEEVEST SECURITIES LIMITED 
银行代码： 016
账户号码： 478-002183148
附注：“Client Account Name” & “Account Number”

美元账户
银行名称： DBS Bank (Hong Kong) Limited
SWIFT码： DHBKHKHHXXX 
户口名称： BEEVEST SECURITIES LIMITED - CLIENT AC
银行代码： 016
账户号码： 478-002183148
附注："“Client Account Name”"& “Account Number”
`;

export default {
  name: "Home",
  components: {
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Icon.name]: Icon,
  },
  data() {
    return {
      form: {},
      // isAdopt: "",
      isMajorLocal: false,
      typeList: [
        "个人资料",
        "衍生产品认知",
        "专业投资者评估",
        "投资风险取向",
        "风险披露",
        "上传材料",
      ],
    };
  },
  computed: {
    //
    showA() {
      const { net_state } = this.form;
      if (net_state <= 2) return true;
      return false;
    },
    showB() {
      const { net_state } = this.form;
      if (net_state !== 3 && this.form.auth_type === "香港/合资格银行") return true;
      return false;
    },
    showC() {
      const { mail_state } = this.form;
      if (mail_state === 4) return true;
      return false;
    },
    showD() {
      const { mail_state } = this.form;
      if (mail_state !== 3) return true;
      return false;
    },
    showE() {
      const { net_state } = this.form;
      if (net_state === 4) return true;
      return false;
    },
    showYearlyRiskBtn() {
      const y = this.yearlyRiskState;
      // -1-不可风险更新，0-可进行风险更新，1-风险更新已提交，2-风险更新审批中，4-风险更新退回，3-风险更新通过
      return y === 0 || y === 1 || y === 2 || y === 4;
    },
    isOpenOnline() {
      // 0-线上开户，1-线下开户
      return this.lineType !== 1;
    },
    isAdopt() {
      return (
        // 线上开户
        (this.form.net_state === 3 && this.form.mail_state === 3) ||
        // 线下开户
        (!this.isOpenOnline && this.form.oa_state === 1)
      );
    },
    // 开户成功展示按钮
    investorConfig() {
      // 补充开户
      const showAddAccount =
        this.addInfo &&
        this.isOpenOnline &&
        (this.addInfo.account_type === "证券保证金账户 " || this.addInfo.major_invester !== "是");
      // 开立子账户
      const showOpenSubAccount = !!this.form.isda_type || !this.isOpenOnline;
      // 风险评测
      const showYearlyRisk = this.showYearlyRiskBtn;
      // isda 查看 新开按钮
      const showIsda = !!this.form.isda_type || !this.isOpenOnline;
      const showIsdaBtnText =
        this.form.isda_state === 0
          ? "TRS收益互换衍生品服务( 仅限专业投资者 )"
          : "TRS收益互换衍生品服务查询";
      // 更改账户资料
      const showChangeInfo = true;
      // 查看当前有效资料
      const showViewInfo = this.isOpenOnline;

      // 是否展示账户管理
      const accountManage = showAddAccount || showOpenSubAccount || showYearlyRisk || showIsda;
      // 是否展示个人信息维护
      const accountInfo = showChangeInfo || showViewInfo;
      return {
        accountManage,
        accountInfo,
        showAddAccount,
        showOpenSubAccount,
        showYearlyRisk,
        showIsda,
        showIsdaBtnText,
        showChangeInfo,
        showViewInfo,
      };
    },
  },
  async mounted() {
    const result = await httpApi.getApproveStatus();
    if (!result) return;
    this.form = result.data;
    // const isAdopt =
    // this.isAdopt = isAdopt;
    this.isMajorLocal =
      this.form.auth_type === "香港/合资格银行" && this.form.major_invester === "否";
    if (this.form.oa_state === 1 && this.form.isda_type) {
      httpApi.getIsdaState();
    }
  },
  methods: {
    async handleAddAccount() {
      this.$store.commit("setIsAddAccount", true);
      await this.$api.submitLog({ type: "addOpenAccountLogin" });
      if (this.addInfo) {
        const { addOpenAccountType } = this.addInfo;
        // 已提交默认为审批中....
        if (
          this.addInfo.isAddOpenAccountInfo === "是" &&
          (addOpenAccountType === 2 || addOpenAccountType === 1 || addOpenAccountType === 4)
        ) {
          // 查询界面
          this.$router.push({ path: "/search/addAccount" });
        } else {
          this.$router.push({ path: "/assess/index" });
        }
      }
    },
    async handleRiskUpdate() {
      if (this.yearlyRiskState === 0) {
        this.$router.push({ path: "/riskOrientation/step_one" });
        this.$store.commit("setIsYearlyRisk", true);
      } else {
        this.$router.push({ path: "/search/riskUpdate" });
      }
    },
    getAeIouData: async () => {},
    handleGoCheck() {
      this.$router.push({ path: "/check" });
    },
    handleChangeInfo() {
      if (this.isChangeInfoNew) {
        this.$router.push({ path: "/change/index" });
      } else {
        this.$router.push({ path: "/change/result" });
      }
    },
    handleGoChoose() {
      this.$store.commit("setIsAddAccount", false);
      this.$router.push({ path: "/choose/index" });
    },
    handleGoIsda() {
      const { cookiePhone, cookieExpires, isDark, platform } = this.$store.state.user;
      const aft = isDark && platform === "APP" ? "&platform=AppDark" : "";
      if (this.form.isda_state === 0) {
        window.location.replace(
          `${
            window.location.protocol
          }//${this.$util.getIsdaHostInKH()}/isda/aggrement?c=${cookiePhone}&e=${cookieExpires}${aft}`
        );
      } else {
        window.location.replace(
          `${
            window.location.protocol
          }//${this.$util.getIsdaHostInKH()}/isda/search?c=${cookiePhone}&e=${cookieExpires}${aft}`
        );
      }
    },
    handleOpenSubAccount() {
      const { cookiePhone, cookieExpires, isDark, platform } = this.$store.state.user;
      const aft = isDark && platform === "APP" ? "&platform=AppDark" : "";

      // 未申请或者已通过 则重新申请，其他状态跳转至结果页查看
      if (this.subAccountState === 0 || this.subAccountState === 3) {
        window.location.replace(
          `${
            window.location.protocol
          }//${this.$util.getIsdaHostInKH()}/isda/openSubAccount?c=${cookiePhone}&e=${cookieExpires}${aft}`
        );
      } else {
        window.location.replace(
          `${
            window.location.protocol
          }//${this.$util.getIsdaHostInKH()}/isda/openSubAccount/search?c=${cookiePhone}&e=${cookieExpires}${aft}`
        );
      }
    },
    handleShowAccount() {
      Dialog.alert({
        title: "收款账户",
        messageAlign: "left",
        message: alertMsg,
        confirmButtonColor: "rgba(0,0,0,0.6)",
        confirmButtonText: "我知道了",
      });
    },
  },
  setup() {
    const email = ref("");
    const lineType = ref(""); // 线下or线上
    const addInfo = ref("");
    const subAccountState = ref(""); // 开立子账户申请状态
    const isChangeInfoNew = ref(false);
    const yearlyRiskState = ref();
    onMounted(async () => {
      const store = useStore();
      store.commit("setTitleValue", "查询");
      store.commit("setStepsValue", ["填写资料(1/5)", "风险认知", "提交资料"]);
      store.commit("setStepsShow", false);
      store.commit("setTitleLeft", true);
      const accountInfo = await httpApi.getOpenAccountInfo();
      if (accountInfo) {
        email.value = accountInfo.data.email;
        lineType.value = accountInfo.data.line_type;
        yearlyRiskState.value = accountInfo.data.yearlyRiskState;
      }

      const addAccountInfo = await httpAddApi.getOpenAccountInfo();
      if (addAccountInfo) addInfo.value = addAccountInfo;

      const res = await httpApi.getSubAccountState();
      if (res) {
        subAccountState.value = res.data.subAccountState;
      }
      const stateResult = await httpApi.changeInfoGetState();
      isChangeInfoNew.value =
        stateResult.data.changeState === 0 || stateResult.data.changeState === 3;
    });
    return {
      email,
      lineType,
      addInfo,
      subAccountState,
      isChangeInfoNew,
      yearlyRiskState,
    };
  },
};
</script>

<style lang="less">
.message {
  padding: @space-0;
  text-align: left;
  div {
    margin-bottom: @space-1;
  }
}
.step {
  background-color: transparent;
  text-align: left;
  margin-left: calc(@space-0 * 2);
}
.van-step {
  padding-left: @space-1;
}
.circle {
  border: 1px solid red;
  border-radius: 50%;
  text-align: center;
  width: 16px;
  height: 16px;
  .van-icon {
    width: 16px;
    height: 16px;
    line-height: 16px;
    color: red;
  }
}
.right {
  border: 1px solid green;
  .van-icon {
    color: green;
  }
}
.image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.home {
  padding-left: @space-1;
  padding-right: @space-1;
}
.wraper {
  text-align: left;
}
.btn-card {
  margin-top: 20px;
  text-align: left;
  .title {
    background: white;
    border-bottom: 4px solid #f6f6f6;
    padding: 5px;
    margin: 0px;
  }
  .row {
    display: flex;
    align-items: center;
    padding: 6px 5px;
    background: white;
    border-bottom: 1px solid #f6f6f6;
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
</style>
